<script>
    import { onMount } from "svelte";
    import { showplus,cancalAdd,title } from '../store.js';
    import { slide } from 'svelte/transition';
    import Ddfcard from "../components/Ddfcard.svelte";
    import store from 'store'
    let haoma = [];
    let choose_id = 0;
    let action_id = 0;
    onMount(() => {
        let temp = [];
        store.each(function(value, key) {
            if (key.indexOf("ddf") === 0) {
                temp.push({
                    key: key,
                    value: value
                });
            }
        })
        haoma = temp.sort((a, b) => {
            return a.key > b.key ? 1 : -1;
        });
        if(haoma.length == 0){
            addOne();
            showplus.set(false);
        }
        app.setTitle('大乐透单复式选号');
        title.set('大乐透单复式选号');
    });
    $: if(choose_id == 0){
        showplus.set(true);
    }else{
        showplus.set(false);
    }
    $: if($cancalAdd){
        let key = $cancalAdd;
        cancalAdd.set(false);
        store.remove(key);
        haoma.forEach(function(item,index,self){
            if(item.key == key){
                self.splice(index,1);
            }
        });
        haoma = haoma
    }
    function addOne(){
        let key = 'ddf'+Date.now();
        haoma.push({key: key,value:{reds:[],blues:[],nums:1,price:0}});
        haoma = haoma;
        choose_id = key;
        action_id = 0;
        cancalAdd.set(false);
    }
    const handleDel = (e) => {
        store.remove(e.detail.key);
        haoma.forEach(function(item,index,self){
            if(item.key == e.detail.key){
                self.splice(index,1);
            }
        });
        haoma = haoma;
        showplus.set(true);
    }
</script>
<div style="height: 2rem;"></div>
{#each haoma as h, i}
    <Ddfcard bind:value={h.value} bind:key={h.key} bind:choose_panel={choose_id} bind:action_id={action_id} on:del={handleDel}/>
{/each}
{#if $showplus}
<div class="plus-one" on:click={addOne} transition:slide="{{ duration: 200 }}">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 256c0 17.69-14.33 32.01-32 32.01H256v144c0 17.69-14.33 31.99-32 31.99s-32-14.3-32-31.99v-144H48c-17.67 0-32-14.32-32-32.01s14.33-31.99 32-31.99H192v-144c0-17.69 14.33-32.01 32-32.01s32 14.32 32 32.01v144h144C417.7 224 432 238.3 432 256z"/></svg>
</div>
{/if}

<style>
    .plus-one {
        width: 56%;
        height: 2.4rem;
        border-radius: 1rem;
        background-color: #183153;
        margin: 0.2rem auto;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .plus-one svg {
        width: 1.4rem;
        height: 1.4rem;
    }
    .plus-one svg path{
        fill: #ffffff;
    }
</style>
